import { Button, Stack, Typography } from '@chronosphereio/chrono-ui';
import { KeyboardReturn as KeyboardReturnIcon } from 'mdi-material-ui';
import { useQueryEditorContext } from '../../query-editor-context';
import { AIEditShortcutPill, getCommandSymbol } from './AIEditShortcutPill';
import { useAIEdit } from './ai-edit-context';

/**
 * Accept / reject bar for AI-generated suggestions.
 *
 * Shows "Accept and run" (Cmd+Enter) only when the query editor has an
 * `onRun` callback, matching the PromQL pattern. When `onRun` is absent
 * (e.g., Logs), only "Accept" (Tab) and "Reject" (Esc) are shown.
 *
 * Analytics callbacks (`onAccept`/`onReject`) are configured on the
 * AIEditProvider and fire automatically from the context actions.
 */
export function AIEditReactionButtons() {
  const { onRun } = useQueryEditorContext();
  const { suggestion, accept, acceptAndRun, reject } = useAIEdit();

  if (!suggestion) return null;

  return (
    <Stack direction="row" gap={1} bgcolor="background.default" paddingX={1} paddingBottom={1}>
      {onRun && (
        <Button size="small" variant="primary" sx={{ pl: 1, pr: 0.5 }} onClick={acceptAndRun}>
          Accept and run
          <AIEditShortcutPill sx={{ ml: 1 }}>
            <Typography variant="code" sx={{ fontSize: '0.75rem', display: 'flex', alignItems: 'center', gap: 0.25 }}>
              {getCommandSymbol()} <KeyboardReturnIcon />
            </Typography>
          </AIEditShortcutPill>
        </Button>
      )}
      <Button size="small" variant={onRun ? 'secondary' : 'primary'} sx={{ pl: 1, pr: 0.5 }} onClick={accept}>
        Accept
        <AIEditShortcutPill sx={{ ml: 1 }}>
          <Typography variant="code" sx={{ fontSize: '0.75rem', color: onRun ? 'text.secondary' : undefined }}>
            Tab
          </Typography>
        </AIEditShortcutPill>
      </Button>
      <Button size="small" variant="secondary" sx={{ pl: 1, pr: 0.5 }} onClick={reject}>
        Reject
        <AIEditShortcutPill sx={{ ml: 1 }}>
          <Typography variant="code" sx={{ fontSize: '0.75rem', color: 'text.secondary' }}>
            Esc
          </Typography>
        </AIEditShortcutPill>
      </Button>
    </Stack>
  );
}
